import { blobticService } from '../../Commun/services/blobticService';

export interface FuelTransaction {
    id: number;
    uid?: string;
    vehicleId?: number;
    fuelCardId?: number;
    driverId?: number;
    date: Date;
    liters: number;
    cost: number;
    odometer: number;
    station?: string;
    product?: string;
    pricePerLiter?: number;
    vehicleRegistration?: string;
    driverName?: string;
    fuelCardNumber?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface FuelDto {
    FTR_IDF: number;
    FTR_UIDF: string;
    VEH_IDF?: number;
    FCD_IDF?: number;
    DRV_IDF?: number;
    FTR_DATE?: string;
    FTR_LITRES?: number;
    FTR_COUT?: number;
    FTR_ODOMETER?: number;
    FTR_STATION?: string;
    FTR_PRODUCT?: string;
    FTR_PRIX_LITRE?: number;
    VEH_REGISTRATION?: string;
    DRV_NAME?: string;
    FCD_NUMBER?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: FuelDto): FuelTransaction => ({
    id: dto.FTR_IDF,
    uid: dto.FTR_UIDF,
    vehicleId: dto.VEH_IDF,
    fuelCardId: dto.FCD_IDF,
    driverId: dto.DRV_IDF,
    date: dto.FTR_DATE ? new Date(dto.FTR_DATE) : new Date(),
    liters: dto.FTR_LITRES || 0,
    cost: dto.FTR_COUT || 0,
    odometer: dto.FTR_ODOMETER || 0,
    station: dto.FTR_STATION,
    product: dto.FTR_PRODUCT,
    pricePerLiter: dto.FTR_PRIX_LITRE,
    vehicleRegistration: dto.VEH_REGISTRATION,
    driverName: dto.DRV_NAME,
    fuelCardNumber: dto.FCD_NUMBER,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const fuelApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_fuel_transaction,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<FuelTransaction>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_fuel_transaction,Insert',
            VEH_IDF: data.vehicleId,
            FCD_IDF: data.fuelCardId,
            DRV_IDF: data.driverId,
            FTR_DATE: data.date ? data.date.toISOString() : new Date().toISOString(),
            FTR_LITRES: data.liters,
            FTR_COUT: data.cost,
            FTR_ODOMETER: data.odometer,
            FTR_STATION: data.station,
            FTR_PRODUCT: data.product,
            FTR_PRIX_LITRE: data.pricePerLiter
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<FuelTransaction>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_fuel_transaction,Update',
            FTR_IDF: id,
            VEH_IDF: data.vehicleId,
            FCD_IDF: data.fuelCardId,
            DRV_IDF: data.driverId,
            FTR_DATE: data.date ? data.date.toISOString() : undefined,
            FTR_LITRES: data.liters,
            FTR_COUT: data.cost,
            FTR_ODOMETER: data.odometer,
            FTR_STATION: data.station,
            FTR_PRODUCT: data.product,
            FTR_PRIX_LITRE: data.pricePerLiter
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_fuel_transaction,Delete', FTR_IDF: id }
        });
        return response;
    }
};
